import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const ClosingCtaSection = () => {
  const { lang, t } = useI18n();

  return (
    <section className="bg-brand-black py-20 md:py-24 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="container mx-auto max-w-[760px] text-center"
      >
        <h2 className="font-display text-3xl md:text-5xl text-white leading-[1.1] mb-5">
          {t.closingCta.h2[lang]}
        </h2>
        <p className="font-light text-base md:text-lg text-white/70 mb-8 max-w-[520px] mx-auto">
          {t.closingCta.sub[lang]}
        </p>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-3.5 rounded-sm text-xs font-semibold uppercase tracking-[0.2em] hover:opacity-90 transition-opacity"
        >
          {t.closingCta.cta[lang]}
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </a>
        <div className="mt-4 text-[12px] text-white/55 tracking-wide">
          {t.closingCta.reassurance[lang]}
        </div>
      </motion.div>
    </section>
  );
};

export default ClosingCtaSection;
